import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const STATUS_DOT = {
  pending: 'bg-amber-500',
  confirmed: 'bg-blue-500',
  completed: 'bg-green-500',
  cancelled: 'bg-gray-400',
};

const MONTHS = ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'];
const DAYS = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];

const AppointmentCalendar = ({ appointments, month, setMonth }) => {
  const year = month.getFullYear();
  const m = month.getMonth();
  const firstDay = new Date(year, m, 1).getDay();
  const offset = firstDay === 0 ? 6 : firstDay - 1;
  const daysInMonth = new Date(year, m + 1, 0).getDate();

  const byDate = {};
  appointments.forEach((apt) => {
    if (!apt.date) return;
    if (!byDate[apt.date]) byDate[apt.date] = [];
    byDate[apt.date].push(apt);
  });
  const cells = [];
  for (let i = 0; i < offset; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  const todayStr = new Date().toISOString().slice(0, 10);
  const prevMonth = () => setMonth(new Date(year, m - 1, 1));
  const nextMonth = () => setMonth(new Date(year, m + 1, 1));
  const dateKey = (d) => year + '-' + String(m + 1).padStart(2, '0') + '-' + String(d).padStart(2, '0');

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <button onClick={prevMonth} className="p-2 rounded-lg hover:bg-[#F8FAFC] border border-[#E2E8F0]">
          <ChevronLeft className="w-4 h-4" />
        </button>
        <h4 className="font-semibold text-[#0F172A]">{MONTHS[m]} {year}</h4>
        <button onClick={nextMonth} className="p-2 rounded-lg hover:bg-[#F8FAFC] border border-[#E2E8F0]">
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>

      <div className="grid grid-cols-7 gap-1 mb-1">
        {DAYS.map((d) => (
          <div key={d} className="text-center text-xs font-medium text-[#64748B] py-1">{d}</div>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-1">
        {cells.map((d, i) => {
          if (d === null) return <div key={'empty-' + i} className="min-h-[80px]" />;
          const key = dateKey(d);
          const dayApts = byDate[key] || [];
          const isToday = key === todayStr;

          return (
            <div key={key} className={'min-h-[80px] border rounded-lg p-1.5 ' + (isToday ? 'border-[#0596DE] bg-blue-50' : 'border-[#E2E8F0]')}>
              <div className={'text-xs font-semibold mb-1 ' + (isToday ? 'text-[#0596DE]' : 'text-[#0F172A]')}>{d}</div>
              <div className="space-y-1">
                {dayApts.slice(0, 3).map((apt) => (
                  <div key={apt.appointment_id} className="text-[10px] leading-tight bg-[#F8FAFC] rounded px-1 py-0.5 flex items-center gap-1">
                    <span className={'w-1.5 h-1.5 rounded-full shrink-0 ' + (STATUS_DOT[apt.status] || 'bg-gray-300')} />
                    <span className="truncate">{apt.time} {apt.patient ? apt.patient.name : ''}</span>
                  </div>
                ))}
                {dayApts.length > 3 && (
                  <div className="text-[10px] text-[#64748B] px-1">+{dayApts.length - 3} autre(s)</div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <div className="flex items-center gap-4 mt-4 flex-wrap text-xs text-[#64748B]">
        <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-amber-500" /> En attente</span>
        <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-blue-500" /> Confirme</span>
        <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-green-500" /> Termine</span>
        <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-gray-400" /> Annule</span>
      </div>
    </div>
  );
};

export default AppointmentCalendar;
